import { render, staticRenderFns } from "./HrPerfDailyReward.vue?vue&type=template&id=0264b27c&scoped=true&"
import script from "./HrPerfDailyReward.vue?vue&type=script&lang=js&"
export * from "./HrPerfDailyReward.vue?vue&type=script&lang=js&"
import style0 from "./HrPerfDailyReward.vue?vue&type=style&index=0&id=0264b27c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0264b27c",
  null
  
)

export default component.exports